var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22493 3.14453H6.8916L8.22494 6.47786L6.55827 7.47786C7.27224 8.92555 8.44391 10.0972 9.8916 10.8112L10.8916 9.14453L14.2249 10.4779V13.1445C14.2249 13.4982 14.0845 13.8373 13.8344 14.0873C13.5844 14.3374 13.2452 14.4779 12.8916 14.4779C10.2911 14.3198 7.83837 13.2155 5.99615 11.3733C4.15394 9.5311 3.04963 7.07836 2.8916 4.47786C2.8916 4.12424 3.03208 3.7851 3.28213 3.53506C3.53217 3.28501 3.87131 3.14453 4.22493 3.14453Z",
    stroke: "#FD4319",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.6e163d4631e84361debaedacada950ed.svg";
export { ForwardRef as ReactComponent };